import { Sparkles } from 'lucide-react';
import { AI_UI_STATES } from '../../constants/aiSearchIntents';
import { UI_STATE_COLORS } from './uiStateColors';
import AIDisclaimer from './AIDisclaimer';

const AISummaryCard = ({
  summary,
  uiState,
  isOffTopic,
  disclaimer,
  headingRef,
}) => {
  const effectiveState = isOffTopic ? AI_UI_STATES.INFO : uiState;
  const theme =
    UI_STATE_COLORS[effectiveState] || UI_STATE_COLORS[AI_UI_STATES.NORMAL];

  if (!summary) return null;

  return (
    <section aria-labelledby="ai-summary-heading">
      <h2
        id="ai-summary-heading"
        ref={headingRef}
        tabIndex={-1}
        className="sr-only focus:outline-none"
      >
        AI Summary
      </h2>
      <div
        className={`p-4 rounded-xl border ${theme.bg} ${theme.border}`}
      >
        <div className="flex items-start gap-3">
          <div
            className={`w-8 h-8 rounded-full ${theme.iconBg} flex items-center justify-center flex-shrink-0`}
          >
            <Sparkles
              className={`w-4 h-4 ${theme.iconText}`}
              aria-hidden="true"
            />
          </div>
          <div className="min-w-0">
            <p className={`text-sm font-medium ${theme.text}`}>{summary}</p>
            <p className="text-xs text-gray-500 mt-2 flex items-center gap-1">
              <Sparkles className="w-3 h-3" aria-hidden="true" />
              AI-generated summary · Animal welfare only
            </p>
          </div>
        </div>
      </div>

      <AIDisclaimer text={disclaimer} />
    </section>
  );
};

export default AISummaryCard;
